/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   useMobileHeaderSticky hooks
 */

import { debounce } from '@zcode/utils'
import { useEffect, useState } from 'react'

export const useMobileHeaderSticky = () => {
  const [isSticky, setSticky] = useState(false)

  const handleScroll = () => {
    // use mobile nav height with some buffer for filter bar
    window?.scrollY > 150 ? setSticky(true) : setSticky(false)
  }

  useEffect(() => {
    window?.addEventListener?.('scroll', debounce(handleScroll, 20))
    return () => {
      window?.removeEventListener?.('scroll', () => handleScroll)
    }
  }, [])

  return { isSticky }
}
